import React from 'react';
import { FadeIn, Section, CtaButton } from './Shared';
export const FinalCtaSection = () => {
  return <Section bg="white" className="text-center" data-id="element-106">
      <div className="max-w-2xl mx-auto" data-id="element-107">
        <FadeIn data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-109">
            Tu cuerpo ya te está dando señales.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-110">
          <p className="text-xl md:text-2xl text-gray-600 mb-8" data-id="element-111">
            Puedes ignorarlas…{' '}
            <span className="font-bold text-brand-teal" data-id="element-112">O empezar hoy.</span>
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-113">
          <CtaButton className="text-xl md:text-2xl py-5 px-10" data-id="element-114">
            👉 COMENZAR AHORA
          </CtaButton>
        </FadeIn>
      </div>
    </Section>;
};